import { useRef, useEffect } from "react";
import { debounce } from "lodash";

export function useDebounce<T extends unknown[]>(
  fn: (...args: T) => void,
  args: T,
  options: UseDebounceOptions<T> = {}
) {
  const debounced = useRef(debounce(fn, options.wait || 500));
  useEffect(() => debounced.current(...args), args);
}

interface UseDebounceOptions<T> {
  wait?: number;
}
